import { PostProperties } from "../types";
import image from "../img/lostGemCollabs3000.jpg";

const post: PostProperties = {
  id: 41,
  title:
    "Collabs 3000 (Speedy J & Chris Liebing) - DEMF, Hart Plaza, Detroit (05.28.2006)",
  content: `Speedy J and Chris Liebing are well-known under their collaborative project, Collabs 3000. This fusion of their individual styles has evolved throughout the years and is still going strong in 2025. This mix showcases the early years of the project, giving listeners a chance to experience the early soundscapes that the duo created.`,
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/collabs-3000-speedy-j-chris-liebing-demf-hart-plaza-detroit-05282006",
  category: "Lost Gem",
  translationsBg: {
    content: `Спийди Джей и Крис Либинг са добре познати със съвместния си проект Collabs 3000. Това сливане на индивидуалните им стилове се е развивало през годините и все още е силно актуално през 2025 г. Този микс показва ранните години на проекта, давайки на слушателите възможност да се докоснат до ранните звукови пейзажи, създадени от дуото.`,
  },
};

export default post;
